import { selectCurrentMenuTypeId } from './chunk-BHZZAODT.mjs';
import { registerMenuTypeDropdownFactory, allRegisterMenuTypeDropdownFactory } from './chunk-NV3573F4.mjs';
import { selectActualMenuType } from './chunk-PHOCK55S.mjs';
import { createSelector } from 'reselect';

var selectedMenuMode = (state) => {
  return state && state.register.registerNavigation.isPreviewMode && selectActualMenuType(state) ? selectActualMenuType(state) : "locationMenu";
};
var selectSelectedMenu = (state) => state.menu[selectedMenuMode(state)];
var selectLocationMenuTypeBucket = (state) => state.menu[selectedMenuMode(state)].menuTypes;
var selectLocationSubcategoryBucket = (state) => state.menu[selectedMenuMode(state)].subcategories;
var selectLocationCategoryBucket = (state) => state.menu[selectedMenuMode(state)].categories;
var selectLocationItemBucket = (state) => state.menu[selectedMenuMode(state)].items;
var selectLocationComboBucket = (state) => state.menu[selectedMenuMode(state)].combos;
var selectLocationModifierGroups = (state) => state.menu[selectedMenuMode(state)].modifierGroups;
var selectLocationModifierItems = (state) => state.menu[selectedMenuMode(state)].modifierItems;
var selectCurrentHotButtons = (state) => state.menu[selectedMenuMode(state)].hotButtons;
var selectCurrentItems = (state) => state.menu[selectedMenuMode(state)].items;
var selectRegisterNavigationMenuType = createSelector(
  selectCurrentMenuTypeId,
  selectLocationMenuTypeBucket,
  (selectedMenuTypeId, menuTypesBucket) => {
    if (!selectedMenuTypeId)
      return null;
    return menuTypesBucket[selectedMenuTypeId];
  }
);
var selectMenuTypeItemsSet = createSelector(
  selectRegisterNavigationMenuType,
  (menuType) => menuType ? new Set(menuType.itemIds) : /* @__PURE__ */ new Set()
);
var selectMenuTypeCombosSet = createSelector(
  selectRegisterNavigationMenuType,
  (menuType) => menuType ? new Set(menuType.comboIds) : /* @__PURE__ */ new Set()
);
var selectMenuTypeDropdownList = createSelector(
  selectLocationMenuTypeBucket,
  registerMenuTypeDropdownFactory
);
var selectAllMenuTypeDropdownList = createSelector(
  selectLocationMenuTypeBucket,
  allRegisterMenuTypeDropdownFactory
);

export { selectAllMenuTypeDropdownList, selectCurrentHotButtons, selectCurrentItems, selectLocationCategoryBucket, selectLocationComboBucket, selectLocationItemBucket, selectLocationMenuTypeBucket, selectLocationModifierGroups, selectLocationModifierItems, selectLocationSubcategoryBucket, selectMenuTypeCombosSet, selectMenuTypeDropdownList, selectMenuTypeItemsSet, selectRegisterNavigationMenuType, selectSelectedMenu };
